export default [
  {
    name: 'miniappRegister',
    path: '/miniappRegister/index',
    meta: { title: '微赞直播' },
    component: () =>
      import(
        /* webpackChunkName: "miniappRegister" */ '../../pages/miniappRegister/index'
      )
  }
]
